/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Button, Tag, Form, Input, Select, Table, Drawer } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTER } from '../../constants/router';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import IconEmpty from './components/iconEmpty';
import DPIAService from '../../services/DPIA.service';
import { useDpiaContext } from './dpia.context';
import { CloseOutlined } from '@ant-design/icons';
import History from './components/History';
import useNotify from '../../context/Notification/useNotify';
import ModalDelete from '../../components/Shared/modal/delete';
import usePermission from '../../hooks/usePermission';

export const statusSwitch = (t, status) => {
    if (status === 'Done') {
        return (
            <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white w-max m-auto">
                {t('Done')}
            </Tag>
        );
    } else {
        return (
            <Tag className="rounded-xl -my-1 text-center bg-lightYellow border-lightYellow text-white w-max m-auto">
                <div>{t('InProgress')}</div>
            </Tag>
        );
    }
};

const ListDPIA = () => {
    const { t, i18n } = useTranslation(['translation', 'dpia']);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    const [dpiaId, setDpiaId] = useState('');
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const notify = useNotify();

    const { isAuditor } = usePermission();

    const [dpiaList, setDpiaList] = useState([]);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'modify_date',
        sortDirection: 'desc',
        total: 0,
    });
    const [allValues, setAllValues] = useState();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [statusList, setStatusList] = useState([]);
    const { status } = useDpiaContext();
    const paginationProps = {
        current: parseInt(currentPage.page),
        total: parseInt(currentPage.total),
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'modify_date',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'desc',
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        getDpiaList(allValues, pageValues);
    };

    const columns = [
        {
            title: t('DPIA Name'),
            dataIndex: 'dpia_name',
            key: 'dpia_name',
            sorter: true,
            render: (text, record) => {
                return (
                    <div>
                        <div className="text-[#65707A] font-semibold text-sm">
                            {text}
                        </div>
                        <div>{record.dpiaName}</div>
                    </div>
                );
            },
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status, record) => statusSwitch(t, record.status),
        },
        {
            title: t('Last edited by'),
            dataIndex: 'modify_date',
            key: 'modify_date',
            sorter: true,
            render: (text, record) => {
                return (
                    <div className="text-[#65707A] font-semibold text-sm">
                        <p>{record.modifyBy}</p>
                        <p>{record.modifyDate}</p>
                    </div>
                );
            },
        },
        {
            title: t('Dataflow related'),
            dataIndex: 'dataFlowRelated',
            key: 'dataFlowRelated',
            sorter: false,
            align: 'center',
            className: 'text-[#65707A] font-semibold text-sm',
            render: (text, record) => record.dataflowRelate ?? '-',
        },
        {
            title: t('Action'),
            align: 'center',
            render: (_, record) => {
                return (
                    <div>
                        <button
                            disabled={isAuditor}
                            type="button"
                            onClick={() =>
                                navigate(
                                    `${ROUTER.DPIA.DEFAULT}/${record.dpiaId}`
                                )
                            }
                            className="pr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="32"
                                    height="32"
                                    rx="6"
                                    fill="#F3F6F9"
                                />
                                <path
                                    d="M20.6587 9.34133L22.6587 11.3413L21.134 12.8667L19.134 10.8667L20.6587 9.34133ZM13.3334 18.6667H15.3334L20.1914 13.8087L18.1914 11.8087L13.3334 16.6667V18.6667Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </button>
                        <button
                            disabled={isAuditor}
                            type="button"
                            className="pr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={() => {
                                setDpiaId(record.dpiaId);
                                setOpenConfirmDelete(true);
                            }}
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="32"
                                    height="32"
                                    rx="6"
                                    fill="#F3F6F9"
                                />
                                <path
                                    d="M16 9C16.549 8.99992 17.0781 9.20504 17.4835 9.57509C17.8889 9.94513 18.1413 10.4534 18.1912 11H21.6C21.7521 11 21.8984 11.0578 22.0095 11.1616C22.1206 11.2654 22.1881 11.4074 22.1985 11.5591C22.2088 11.7108 22.1612 11.8607 22.0653 11.9786C21.9694 12.0966 21.8322 12.1737 21.6816 12.1944L21.6 12.2H21.1336L20.12 20.984C20.0749 21.3739 19.888 21.7336 19.5949 21.9947C19.3018 22.2558 18.923 22.4001 18.5304 22.4H13.4696C13.0771 22.4001 12.6983 22.2558 12.4052 21.9947C12.1121 21.7336 11.9252 21.3739 11.88 20.984L10.8656 12.2H10.4C10.2551 12.2 10.115 12.1475 10.0057 12.0522C9.89643 11.9569 9.82537 11.8252 9.80565 11.6816L9.80005 11.6C9.80005 11.455 9.85256 11.3149 9.94786 11.2057C10.0432 11.0964 10.1748 11.0253 10.3184 11.0056L10.4 11H13.8088C13.8587 10.4534 14.1112 9.94513 14.5166 9.57509C14.922 9.20504 15.4511 8.99992 16 9ZM14.8 14C14.604 14 14.44 14.124 14.4064 14.2872L14.4 14.3504V19.2504L14.4064 19.3128C14.44 19.476 14.604 19.6 14.8 19.6C14.996 19.6 15.16 19.476 15.1936 19.3128L15.2 19.2496V14.3512L15.1936 14.2872C15.16 14.1248 14.996 14 14.8 14ZM17.2 14C17.004 14 16.84 14.124 16.8064 14.2872L16.8 14.3504V19.2504L16.8064 19.3128C16.84 19.476 17.004 19.6 17.2 19.6C17.396 19.6 17.56 19.476 17.5936 19.3128L17.6 19.2496V14.3512L17.5936 14.2872C17.56 14.1248 17.396 14 17.2 14ZM16 10.2C15.516 10.2 15.112 10.544 15.02 11H16.98C16.8872 10.544 16.484 10.2 16 10.2Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </button>
                        <button
                            disabled={isAuditor}
                            type="button"
                            onClick={() => {
                                setDpiaId(record.dpiaId);
                                setVisible(true);
                            }}
                            className="disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="32"
                                    height="32"
                                    rx="6"
                                    fill="#F3F6F9"
                                />
                                <g clipPath="url(#clip0_11259_45843)">
                                    <path
                                        d="M15.993 9C12.129 9 9 12.136 9 16C9 19.864 12.129 23 15.993 23C19.864 23 23 19.864 23 16C23 12.136 19.864 9 15.993 9ZM16 21.6C12.906 21.6 10.4 19.094 10.4 16C10.4 12.906 12.906 10.4 16 10.4C19.094 10.4 21.6 12.906 21.6 16C21.6 19.094 19.094 21.6 16 21.6ZM16.35 12.5H15.3V16.7L18.975 18.905L19.5 18.044L16.35 16.175V12.5Z"
                                        fill="#7B67FB"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_11259_45843">
                                        <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(8 8)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                );
            },
        },
    ];

    const getDpiaList = async (searchValue, pageValue) => {
        setLoading(true);
        const payload = {
            ...searchValue,
            p: pageValue.page || 1,
            ps: pageValue.pageSize || 10,
            s: pageValue.sortBy || 'modify_date',
            sd: pageValue.sortDirection || 'desc',
        };
        try {
            const { data } = await DPIAService.getDPIAList(payload);
            if (data?.resultCode === 1) {
                setDpiaList(data?.resultData?.result);
                setCurrentPage({
                    page: data?.resultData.page,
                    pageSize: data?.resultData.pageSize,
                    total: data?.resultData.total,
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        getDpiaList(allValues, currentPage);
    }, []);

    useEffect(() => {
        setStatusList(status);
    }, [status]);

    const onFinish = (allValues) => {
        setLoading(true);
        setAllValues(allValues);
        const search = {
            page: 1,
            pageSize: 10,
            sortBy: 'modify_date',
            sortDirection: 'desc',
            total: 0,
        }
        getDpiaList(allValues, search);
    };

    const handleReset = () => {
        form.resetFields();
        setLoading(true);
        setAllValues({});
        getDpiaList({}, { page: 1, pageSize: 10 });
    };
    return (
        <div>
            <div className="title">
                {t('Data Protection Impact Assessment', { ns: 'dpia' })}
            </div>
            <p className="text-gray">{t('DPIA')}</p>
            <div className="mt-6 bg-white p-4 px-6 rounded-lg">
                <div className="text-xl font-medium text-darkGray">
                    {t('Search Filter')}
                </div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    form={form}
                    onFinish={onFinish}
                    layout="inline"
                    className="mt-4"
                >
                    <Form.Item className="mt-4" name="dpiaName">
                        <Input
                            style={{ width: 330 }}
                            size="large"
                            placeholder={t('Assessment Name', { ns: 'dpia' })}
                        />
                    </Form.Item>
                    <Form.Item className="mt-4" name="status">
                        <Select
                            placeholder={t('DPIA status')}
                            style={{ width: 330 }}
                            size="large"
                            allowClear
                        >
                            {statusList?.map((status) => (
                                <Select.Option
                                    key={status?.statusId}
                                    value={status?.statusId}
                                >
                                    {i18n.language === 'en'
                                        ? status.nameEn
                                        : status.nameTh}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <div className="flex items-center mt-4">
                        <Button
                            loading={loading}
                            htmlType="submit"
                            className="bg-purple rounded-md text-white"
                            size="large"
                            type="primary"
                        >
                            {t('Search')}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={handleReset}
                            className="bg-white rounded-md text-purple ml-2 flex items-center hover:text-white focus:text-white"
                            size="large"
                            type="primary"
                            htmlType="button"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15 5.707L14.293 5L12 7.293L9.707 5L9 5.707L11.293 8L9 10.2925L9.7075 11L12 8.707L14.2935 11L15 10.2935L12.707 8L15 5.707Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M2 2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V4.585C0.999962 4.7164 1.02582 4.84651 1.07609 4.96791C1.12637 5.0893 1.20008 5.1996 1.293 5.2925L5 9V13C5 13.2652 5.10536 13.5196 5.29289 13.7071C5.48043 13.8946 5.73478 14 6 14H8C8.26522 14 8.51957 13.8946 8.70711 13.7071C8.89464 13.5196 9 13.2652 9 13V12H8V13H6V8.585L5.707 8.2925L2 4.5855V3H12V4H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H2Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="mt-6 bg-white p-4 px-6 rounded-lg">
                <div className="flex pt-2 justify-between items-end">
                    <div>
                        <h3 className="text-darkGray font-semibold text-xl">
                            {t('DPIA List')}
                        </h3>
                        <p className="text-gray text-sm"> {t('DPIA title')}</p>
                        <p className="text-gray-PHX text-xs font-semibold">
                            {t('total DPIA', { total: currentPage.total })}
                        </p>
                    </div>
                    <div className="self-center">
                        <Link to={`${ROUTER.DPIA.DEFAULT}/new`}>
                            <Button
                                disabled={isAuditor}
                                size="large"
                                type="primary"
                                className="px-4"
                            >
                                {t('Add DPIA')}
                            </Button>
                        </Link>
                    </div>
                </div>
                <Table
                    loading={loading}
                    className="inbox_table"
                    rowKey={(record, i) => i}
                    dataSource={dpiaList}
                    columns={columns}
                    locale={{
                        emptyText: (
                            <div className="my-16">
                                <IconEmpty />
                                <div className="text-sm text-[#65707A] pt-2 pb-4">
                                    {t('No data')}
                                </div>
                            </div>
                        ),
                    }}
                    pagination={paginationProps}
                    onChange={onPageChange}
                />
                <ModalDelete
                    title={t('common.ConfirmDelete')}
                    text={t('common.ConfirmDeleteDpia')}
                    open={openConfirmDelete}
                    handelOk={async () => {
                        try {
                            const { data } = await DPIAService.deleteDPIA(
                                dpiaId
                            );
                            if (data?.resultCode === 1) {
                                setOpenConfirmDelete(false);
                                notify({
                                    title: t('common.Success'),
                                    description: t('Successfully deleted data'),
                                });
                                getDpiaList(allValues, currentPage);
                            } else {
                                setOpenConfirmDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('common.FailedDeleteData'),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            }
                        } catch (err) {
                            setOpenConfirmDelete(false);
                            notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('common.FailedDeleteData'),
                                timeOut: 120000,
                                closeable: true,
                            });
                        }
                    }}
                    handelClose={() => setOpenConfirmDelete(false)}
                />
                <Drawer
                    title={
                        <div className="flex justify-between items-center">
                            <span className="text-purple text-[17px]">
                                {t('History')}
                            </span>
                            <button
                                type="button"
                                onClick={(e) => setVisible(false)}
                                className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                            >
                                <CloseOutlined />
                            </button>
                        </div>
                    }
                    placement="right"
                    onClose={() => setVisible(false)}
                    closable={false}
                    open={visible}
                    className="history"
                    width={500}
                >
                    <History dpiaId={dpiaId} visible={visible} />
                </Drawer>
            </div>
        </div>
    );
};

export default ListDPIA;
